import { render, staticRenderFns } from "./EditBactOrga.vue?vue&type=template&id=4a1ee0fc&scoped=true"
import script from "./EditBactOrga.vue?vue&type=script&lang=js"
export * from "./EditBactOrga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1ee0fc",
  null
  
)

export default component.exports